import type { SVGProps } from "react";
export const Remove = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path d="M5.5 12.75V11.25H18.5V12.75H5.5Z" fill="currentColor" />
	</svg>
);
